// extracted by mini-css-extract-plugin
export var phone = "_2x-0";
export var phoneDragging = "_2x-1";